import React, { useState } from 'react'
import { Star } from 'lucide-react'

const StarRating = ({
  value,
  onChange,
  choices = [],
  idPrefix = '',
  labelledBy,
}) => {
  const [hovered, setHovered] = useState(null)

  const handleMouseEnter = (index) => setHovered(index)
  const handleMouseLeave = () => setHovered(null)
  const handleClick = (index) => {
    // Toggle off if clicked again
    if (value === index) {
      onChange(0)
    } else {
      onChange(index)
    }
  }

  return (
    <div role="group" aria-labelledby={labelledBy} className="flex gap-4">
      {[1, 2, 3, 4, 5].map((index) => {
        const isFilled = hovered ? index <= hovered : index <= value
        const choiceLabel = choices[index - 1]
        const starLabel = `${index} ${index > 1 ? 'stars' : 'star'}${
          choiceLabel ? `: ${choiceLabel}` : ''
        }`
        return (
          <button
            key={index}
            type="button"
            id={`rating-${idPrefix}-${index}`}
            className="group flex cursor-pointer flex-col items-center rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            aria-pressed={value === index}
            aria-label={starLabel}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onFocus={() => handleMouseEnter(index)}
            onBlur={handleMouseLeave}
            onClick={() => handleClick(index)}
          >
            <Star
              aria-hidden="true"
              className={`h-10 w-10 transition-colors duration-150 ${
                isFilled ? 'text-yellow-400' : 'text-gray-500'
              }`}
              fill={isFilled ? 'currentColor' : 'none'}
            />
            <span
              aria-hidden="true"
              className="mt-1 text-center text-sm text-gray-700 group-hover:font-medium"
            >
              {choiceLabel || ''}
            </span>
          </button>
        )
      })}
    </div>
  )
}

export default StarRating
